export default __webpack_public_path__ + "static/media/squigglyBorder.1287b96b.svg";